import React, { useState, useEffect, forwardRef } from "react";
import { instance } from "../../axios";
import { TableZero, PageHeader, UiButton, UiDatePicker, UiClientSelect, BgLoader, InLoader, UiActioButton, UiActionDropDown, UiInput, UiSelect, Avatar, PageError, Toastcontent } from "../../ui";
import { useForm, Controller } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import { Link, useLocation } from "react-router-dom"
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useQuery, useQueryClient, select } from "react-query";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useStore } from "../../state.js";
import { Helmet } from "react-helmet";
import queryString from 'query-string';
import { CSVLink, CSVDownload } from "react-csv";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import ExportPDFButton from '../../pdf_table.js';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { Table } from 'antd';
import { Dropdown, Popconfirm, Menu } from 'antd';
import { getStorage, setStorage, updateFilterUrl, rupees } from "../../helper.js";
import { renderToStaticMarkup } from 'react-dom/server';



export default function BalanceSheet() {
  let navigate = useNavigate();
  const location = useLocation();
  const [fy] = useOutletContext();
  const queryClient = useQueryClient()
  const zstate = useStore((state) => state);
  const setZState = useStore((state) => state.setClients);
  const parsed = queryString.parse(location.search);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);





  const schema = yup.object().shape(
    {

    }
  );


  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    control,
    setValue,
    formState,
    reset,
  } = useForm({
    resolver: yupResolver(schema),
  });


  const onSubmitHandler = async (data) => {

    setSelectedRowKeys([])

    const obj = {};
    Object.entries(data).map(([key, val]) => {
      if (val) {
        obj[key] = Array.isArray(val) ? (val.map(itm => itm.value)).join(',') : val.label ? val.value : val
      }
    })


    navigate(updateFilterUrl(obj, 'balance-sheet', 1), { replace: location.search ? true : false })


  };





  const [filter, setFilter] = useState({});



  async function fetchData(filter) {

    const { data } = await instance.get(
      "/p_and_l" + filter
    );

    var dataa = data;

    return dataa;

  }

  const defaultValues = {
    date: null,
  };



  useEffect(() => {
    queryClient.invalidateQueries(['balance-sheet'])
  }, [fy]);


  useEffect(() => {

    if (location.search) {
    } else {
      setFilter(defaultValues)
    }




  }, [location]);



  useEffect(() => {


    const parsed = queryString.parse(location.search);



    setFilter(parsed)




  }, []);





  const { data, error, isError, isLoading, isFetching } = useQuery(["balance-sheet", location.search], () => fetchData(location.search), {
    keepPreviousData: true,
  });


  useEffect(() => {

    if (zstate) {
      const defaultValues1 = {
        from: filter.from? filter.from : data && data.from ? data.from : null,
        to: filter.to? filter.to : data && data.to ? data.to : null,
      };
      reset(defaultValues1)
    }
  }, [filter]);


  useEffect(() => {

    
    if (data && data.from) {
      setValue('from', data.from)
      setValue('to', data.to)
    }

  }, [data]);



  const generatePDF = () => {
    const doc = new jsPDF('p', 'mm', 'a4');

    const element = document.getElementById('printdiv');

    doc.html(element, {
      callback: function (doc) {
        //doc.save('table.pdf');
        window.open(doc.output('bloburl', 'p&l.pdf'), '_blank');
      },
      x: 10,
      y: 10,
      width: 190,
      windowWidth: 830,
      autoPaging: true, // Automatically manage page breaks
    });
  };



  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    preserveSelectedRowKeys: true,
    onChange: onSelectChange,
  };








  if (isLoading) {
    return <BgLoader />;
  }
  if (!data) {
    return (
      <BgLoader />
    )
  }

  if (data.status == 'error') {
    return (
      <PageError msg={data.msg} code={data.code} />
    )
  }
  if (isError) {
    return <div>Error! {error.message}</div>;
  }

  return (
    <>
      <Helmet>
        <title>
          Balance Sheet
        </title>
      </Helmet>
      <div>
        <div>
          <PageHeader title="Balance Sheet" >

            <UiButton className="btn btn-outline-primary" onClick={generatePDF} title="PDF" />


          </PageHeader>

          <div className="position-relative bg-white rounded mb-4 pb-4">
            <form className="position-relative" onSubmit={handleSubmit(onSubmitHandler)} noValidate>
              <div className="p-3 pb-0">

                <div className="row">

                  <div className="col-md-2">

                    <Controller

                      name="from"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="From"
                          onChange={onChange}
                          default_val={value}
                          message={errors.from?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>

                  <div className="col-md-2">

                    <Controller

                      name="to"
                      control={control}
                      render={({
                        field: { onChange, onBlur, value, name, ref },
                        fieldState: { invalid, isTouched, isDirty, error },
                        formState,
                      }) => (
                        <UiDatePicker

                          required={true}
                          label="To"
                          onChange={onChange}
                          default_val={value}
                          message={errors.to?.message}
                          dateFormat="dd-MM-yyyy"
                          ref={ref}
                          name={name}
                        />
                      )}
                    />


                  </div>





                  <div className="col-md-1" style={{ paddingTop: '28px' }}>
                    <div className="d-flex justify-content-end">

                      <UiButton type="submit" className="ms-2 btn-primary" title="Filter" />
                    </div>

                  </div>
                </div>



              </div>
            </form>
            {data && data.items_bs ? (
              <div className="table-responsive">
              <div className="p-3" id="printdiv" style={{ minWidth:'700px'}}>
                <div className="text-center mb-4">
                  <h2>{data.company}</h2>
                  <h3>Balance Sheet</h3>
                  <p>As on {data.to}</p>
                </div>
                <div className="d-flex pitable bg-white" style={{ minWidth: '800px', width: '100%' }} >
                  <div className="col border" >
                    <div className="d-flex">
                      <div className={`col border-bottom p-1`} style={{ minWidth: '200px' }}>
                        Liabilities
                      </div>
                      <div className="col border-bottom border-start text-end p-1" style={{ maxWidth: '150px' }}>
                        Amount
                      </div>
                    </div>

                    {data.items_bs.liabilities && Object.keys(data.items_bs.liabilities).map(key => (
                      <div key={key} className="d-flex">
                        <div className={`col border-bottom p-1`} style={{ minWidth: '200px' }}>
                          <b>{data.items_bs.liabilities[key].name}</b>
                          <div className="ps-3">
                            {data.items_bs.liabilities[key].items && data.items_bs.liabilities[key].items.map((item, index) => (
                              <div key={index} className="d-flex justify-content-between">
                                <div>
                                  {item.name}
                                </div>
                                <div>{rupees(item.amount)}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="col border-bottom border-start text-end p-1" style={{ maxWidth: '150px' }}>
                          {rupees(data.items_bs.liabilities[key].total)}
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="col border">
                    <div className="d-flex">
                      <div className={`col border-bottom p-1`} style={{ minWidth: '200px' }}>
                        Assets
                      </div>
                      <div className="col border-bottom border-start text-end p-1" style={{ maxWidth: '150px' }}>
                        Amount
                      </div>
                    </div>

                    {data.items_bs.assets && Object.keys(data.items_bs.assets).map(key => (
                      <div key={key} className="d-flex">
                        <div className={`col border-bottom p-1`} style={{ minWidth: '200px' }}>
                          <b>{data.items_bs.assets[key].name}</b>
                          <div className="ps-3">
                            {data.items_bs.assets[key].items && data.items_bs.assets[key].items.map((item, index) => (
                              <div key={index} className="d-flex justify-content-between">
                                <div>
                                  {item.name}
                                </div>
                                <div>{rupees(item.amount)}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="col border-bottom border-start text-end p-1" style={{ maxWidth: '150px' }}>
                          {rupees(data.items_bs.assets[key].total)}
                        </div>
                      </div>
                    ))}

                  </div>
                </div>
                <div className="d-flex pitable bg-white" style={{ minWidth: '800px', width: '100%' }} >
                  <div className="col" >
                    <div className="d-flex">
                      <div className={`col border border-top-0  p-1`} style={{ minWidth: '200px' }}>
                        Total
                      </div>
                      <div className="col border border-top-0 border-start-0 p-1 text-end" style={{ maxWidth: '150px' }}>
                        {rupees(data.items_bs.balance_sheet_total)}
                      </div>
                    </div>
                  </div>
                  <div className="col">

                    <div className="d-flex">
                      <div className={`col border border-top-0  p-1`} style={{ minWidth: '200px' }}>
                        Total
                      </div>
                      <div className="col border border-top-0 border-start-0 p-1 text-end" style={{ maxWidth: '150px' }}>
                        {rupees(data.items_bs.balance_sheet_total)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            ) : <BgLoader />}









          </div>
        </div>
      </div>
    </>
  );
}
